/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type CSSProperties, type FC, type ReactNode } from 'react';

import classNames from 'classnames';

import faviconUrl from './assets/abrain-favicon.ico';
import { getAbrProductName } from './is-abr-rebrand-enabled';

import styles from './abrain-logo.module.less';

export interface AbrainLogoProps {
  isOversea?: boolean;
  showText?: boolean;
  subtitle?: ReactNode;
  size?: number;
  textTone?: 'default' | 'white';
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

export const AbrainLogo: FC<AbrainLogoProps> = ({
  isOversea = false,
  showText = true,
  subtitle,
  size = 32,
  textTone = 'default',
  className,
  style,
  onClick,
}) => (
  <div
    className={classNames(styles.wrap, onClick && styles.clickable, className)}
    style={style}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
  >
    <img
      src={faviconUrl}
      alt={getAbrProductName(isOversea)}
      width={size}
      height={size}
      className={styles.icon}
    />
    {showText ? (
      <div
        className={classNames(
          styles.text,
          textTone === 'white' && styles.textWhite,
        )}
      >
        {getAbrProductName(isOversea)}
        {subtitle ? <small>{subtitle}</small> : null}
      </div>
    ) : null}
  </div>
);
